import { gql, useMutation } from '@apollo/client'
import { useAlert, useNotification } from '@btime/react-messager'
import { useTranslation } from 'react-i18next'

import { accountsClient } from '../../../apollo/api'

const MUTATION = gql`
  mutation RemoveContracts($userIds: [Int]) {
    removeContracts(userIds: $userIds)
  }
`

export const useRemoveContracts = () => {
  const [request, state] = useMutation(MUTATION, {
    refetchQueries: ['Contracts', 'ContractsCount', 'Users', 'UsersCount', 'User'],
    client: accountsClient
  })
  const notify = useNotification()
  const modal = useAlert()
  const { t } = useTranslation('common')

  const handleRequest = userIds => {
    if (!modal.confirm({ title: t('confirmRemove') })) return false

    return request({ variables: { userIds } }).then(resp => {
      if (!!resp.errors) {
        notify.error({ title: t('errorDelete') })
      }
    })
  }

  return [handleRequest, state]
}
